import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'
import { connect } from 'react-redux'

import Home from '../Home'
import InvalidLink from '../InvalidLink'
import Page404 from '../404'
import Header from 'src/components/Header'
import Footer from 'src/components/Footer'
import { WhiteLayout, PaddedContent } from 'src/common/styled'

const App = props => {
  const { user } = props

  return (
    <WhiteLayout>
      <Header user={user} />
      <PaddedContent>
        <Switch>
          <Route component={Home} exact path={'/'} />
          {/* Target of the backend redirect when the magic link is no longer
              usable. Nginx serves index.html for unknown paths (try_files), so
              this client-side route resolves. */}
          <Route component={InvalidLink} exact path={'/link-non-valido'} />
          <Route component={Page404} />
        </Switch>
      </PaddedContent>
      <Footer />
    </WhiteLayout>
  )
}
App.propTypes = {
  user: PropTypes.object
}

const mapStateToProps = state => ({
  user: state.user.current
})
export default connect(mapStateToProps)(App)
